import { render, staticRenderFns } from "./ListOrder.vue?vue&type=template&id=770a3022&scoped=true&"
import script from "./ListOrder.vue?vue&type=script&lang=ts&"
export * from "./ListOrder.vue?vue&type=script&lang=ts&"
import style0 from "./ListOrder.vue?vue&type=style&index=0&id=770a3022&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770a3022",
  null
  
)

export default component.exports